// Configuration for FastAPI backend
const fastAPIBaseURL = process.env.REACT_APP_FASTAPI_URL || "http://localhost:7000";

export default fastAPIBaseURL;

